module.exports = __webpack_public_path__ + "static/media/PBAS.cb35ec19.png";